import { z } from 'zod';

export const agentTodoListSettings = z.object({
  enabled: z.boolean().default(false),
});
export type AgentTodoListSettings = z.infer<typeof agentTodoListSettings>;

export const agentFileSystemSettings = z.object({
  enabled: z.boolean().default(false),
});
export type AgentFileSystemSettings = z.infer<typeof agentFileSystemSettings>;

export const agentMemorySettings = z.object({
  enabled: z.boolean().default(false),
});
export type AgentMemorySettings = z.infer<typeof agentMemorySettings>;

export const agentCitationsSettings = z.object({
  enabled: z.boolean().default(false),
});
export type AgentCitationsSettings = z.infer<typeof agentCitationsSettings>;

export const agentSettingsSchema = z.object({
  citations: agentCitationsSettings,
  fs: agentFileSystemSettings,
  memory: agentMemorySettings,
  todos: agentTodoListSettings,
});

export type AgentSettings = z.infer<typeof agentSettingsSchema>;